import React from "react";
import NumberFormat from "react-number-format";
import { Input } from "reactstrap";

const decimalSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ".";
  return ",";
})();

const thousandSeparator = (() => {
  if (
    typeof window !== "undefined" &&
    window.___APP_CONFIG___ &&
    window.___APP_CONFIG___.DECIMAL_SEPARATOR == "."
  )
    return ",";
  return ".";
})();

const currency =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.CURRENCY
    : "2";

const price =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PRICE
    : "4";

const quantity =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.QUANTITY
    : "8";

const percentage =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.PERCENTAGE
    : "2";

const defaultValue =
  typeof window !== "undefined" && window.___APP_CONFIG___
    ? window.___APP_CONFIG___.DATA_TYPE_DECIMALS.DEFAULT
    : "8";

export const NumberFormatInput = ({
  type = "text",
  placeholder,
  customInput = Input,
  value,
  invalid,
  disabled,
  onValueChange,
  decimalScale = null,
  dataTypeDecimalName = "default",
  ...rest
}) => {
  const decimalAmount = {
    quantity: quantity,
    price: price,
    currency: currency,
    percentage: percentage,
    default: defaultValue,
  };

  //We set the amount of decimals to the default amount.
  let decimals = decimalAmount.default;

  //We lowercase the decimal name
  dataTypeDecimalName ? (dataTypeDecimalName = dataTypeDecimalName.toString().toLowerCase().trim()) : null;

  //If we have a specific amount of decimals, we'll use that one.
  //If we don't have one, but we have a decimal category, we use that one
  //If we don't have anything we use the default amount of decimals.
  decimalScale != null
    ? (decimals = decimalScale)
    : (decimals =
        decimalAmount[dataTypeDecimalName] != undefined ? decimalAmount[dataTypeDecimalName] : decimals);

  return (
    <NumberFormat
      placeholder={placeholder}
      customInput={customInput}
      value={parseFloat(value)}
      invalid={invalid}
      disabled={disabled}
      onValueChange={onValueChange}
      decimalScale={decimals}
      decimalSeparator={decimalSeparator}
      thousandSeparator={thousandSeparator}
      displayType="input"
      {...rest}
    />
  );
};
